import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { configProperties } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ConfigService {
	configUrl: string = configProperties.configPath;
	private configSettings: any = null;

	constructor(private readonly http: HttpClient) {}

	get GSuiteClientID() {
		return this.configSettings.gsuite_client_id;
	}

	/** Host público del despliegue (ConfigMap GKE → `url_dns_host`). Puede incluir puerto, p. ej. `localhost:4200`. */
	get urlDnsHost(): string {
		return this.configSettings?.url_dns_host ?? '';
	}

	/**
	 * Activa Google Analytics según `google_analytics_enabled` en app.config (boolean JSON desde el pipeline).
	 * Acepta boolean nativo o, por compatibilidad, la cadena `"true"`. Si falta la clave, false.
	 */
	get googleAnalyticsEnabled(): boolean {
		const v = this.configSettings?.google_analytics_enabled;
		if (typeof v === 'boolean') {
			return v;
		}
		if (typeof v === 'string') {
			return v.trim().toLowerCase() === 'true';
		}
		return false;
	}

	/** ID GA4 (p. ej. `G-XXXX`). Vacío desactiva la carga de gtag aunque el resto de flags coincida. */
	get googleAnalyticsMeasurementId(): string {
		const v = this.configSettings?.google_analytics_measurement_id;
		return typeof v === 'string' ? v.trim() : '';
	}

	getSettings(key?: string | Array<string>): any {
		if (!key || (Array.isArray(key) && !key[0])) {
			return this.configSettings;
		}

		if (!Array.isArray(key)) {
			key = key.split('.');
		}

		return key.reduce((account: any, current: string) => account && account[current], this.configSettings);
	}

	public load(): Promise<any> {
		return new Promise((resolve, reject) => {
			this.http.get(this.configUrl).subscribe((response: any) => {
				this.configSettings = response;
				resolve(true);
			});
		});
	}
}
